import React, { useState } from "react";
import CustomModal from "../common/Modal";

interface ImpressumProps {
    headerText: string;
}

export const ImpressumModal: React.FC<ImpressumProps> = ({ headerText }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const modal_id = "impressum-modal";

    const handleImpressumModalClose = () => {
        const modal = document.getElementById(modal_id) as HTMLDialogElement;
        if (modal) modal.close();
    };

    return (
        <div className="">
            <button
                className="btn btn-link !text-navbar-item !font-navbar-item !text-darkpink !no-underline hover:!underline"
                onClick={() => {
                    setIsModalOpen(true);
                }}
            >
                Impressum
            </button>
            <CustomModal
                headerText={headerText}
                onCancel={handleImpressumModalClose}
                modal_id={modal_id}
                isOpen={isModalOpen}
                setIsOpen={setIsModalOpen}
            >
                <div className="">
                    <h3 className="label font-modal-item text-modal-item pt-4">
                        Carl Remigius Fresenius Education GmbH
                    </h3>
                    <p className="py-2 font-chat-text text-chat-text">
                        Im MediaPark 4e
                        <br />
                        50670 Köln
                    </p>
                    <p className="py-2 font-chat-text text-chat-text">
                        Telefon: +49 221 92 15 12-0
                        <br />
                        Fax: +49 221 92 15 12-10
                        <br />
                        E-Mail:{" "}
                        <a href="mailto:info@crf-education.com" className="underline">
                            info@crf-education.com
                        </a>
                    </p>
                    <label className="label font-modal-item text-modal-item pt-4">Geschäftsführer</label>
                    <p className="py-2 font-chat-text text-chat-text">Kai Metzner, Werner Unger</p>
                    <label className="label font-modal-item text-modal-item pt-4">Registereintrag</label>
                    <p className="py-2 font-chat-text text-chat-text">
                        Registergericht: Amtsgericht Köln
                        <br />
                        Registernummer: HRB 114828
                        <br />
                        Umsatzsteuer-ID: DE811312936
                    </p>
                    <label className="label font-modal-item text-modal-item pt-4">
                        Informationen zur Streitbeilegung
                    </label>
                    <p className="py-2 font-chat-text text-chat-text">
                        Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{" "}
                        <a
                            href="https://ec.europa.eu/consumers/odr/main/index.cfm?event=main.home.chooseLanguage"
                            target="_blank"
                            className="underline"
                        >
                            ec.europa.eu/consumers/odr/
                        </a>
                        . Wir sind zur Teilnahme an einem Streitbeilegungsverfahren vor einer
                        Verbraucherschlichtungsstelle weder verpflichtet noch bereit.
                    </p>
                </div>
            </CustomModal>
        </div>
    );
};

export default ImpressumModal;
